import React from 'react';
import { Box, Paper } from '@mui/material';
import { IJobOpeningSidebarProps } from '../../Interfaces/sidebar.interface';
import { JobOpeningSidebarItem } from './JobOpeningSidebarItem';

export const JobOpeningSidebar = ({
  buttons,
  currentTab,
  onSelectTab,
}: IJobOpeningSidebarProps) => {
  return (
    <Paper
      elevation={0}
      component='nav'
      aria-label='Job Opening Details Navigation'
      sx={{
        display: 'flex',
        flexDirection: { xs: 'row', lg: 'column' },
        gap: { xs: 0.75, lg: 1 },
        px: 0.75,
        py: { xs: 0.75, lg: 1.5 },
        bgcolor: 'rgba(248, 250, 252, 0.7)',
        border: '1px solid #f1f5f9',
        borderRadius: { xs: '8px', lg: '16px' },
        overflowX: { xs: 'auto', lg: 'visible' },
        overflowY: 'visible',
        width: { xs: '100%', lg: 64 },
        flexShrink: 0,
        position: { xs: 'static', lg: 'sticky' },
        top: { lg: 16 },
        height: { lg: 'fit-content' },
        zIndex: 10,
        boxSizing: 'border-box',
        '&::-webkit-scrollbar': {
          height: 4,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#cbd5e1',
          borderRadius: 2,
        },
      }}
    >
      {buttons.map((button) => {
        if (button.disabled) return null;
        const isActive = currentTab === button.value;

        return (
          <JobOpeningSidebarItem
            key={button.value}
            button={button}
            isActive={isActive}
            onSelect={onSelectTab}
          />
        );
      })}
    </Paper>
  );
};
